export default __webpack_public_path__ + "static/media/797197939910639616.888f2bae.png";